import {
  CREATE_INITIATIVE,
  FIND_INITIATIVES_BY_MUNICIPALITY,
  FIND_ORGANS_BY_MUNICIPALITY,
} from "../queries";
import React, { useState, useEffect } from "react";
import { useQuery, useMutation } from "@apollo/client";
//import bcrypt from "bcryptjs";
//import { useParams } from "react-router-dom";
import { TextField, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
//import Container from "@mui/material/Container";
//import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
//import MKTypography from "components/MKTypography";
// Material Kit 2 React components
//import MKBox from "components/MKBox";
import { FormControl, Select, MenuItem } from "@mui/material";
//import {useTranslation} from "react-i18next"
/*
import {useTranslation} from "react-i18next"
const [t, i18n] = useTranslation("common")
{t("headers.agendas")}

*/
import ReCAPTCHA from "react-google-recaptcha";
/* eslint-disable react/prop-types */
const InitiativeForm = ({ setError, selectedKunta }) => {
  // eslint-disable-next-line
  //const [t, i18n] = useTranslation("common")
  const [t] = useTranslation("common");
  const [initiativetext, setText] = useState("");
  //const [userid, setUser] = useState("werewrwe")
  const [organid, setOrganid] = useState("");
  const [organs, setOrgans] = useState([]);
  //const [initiativedatetime, setDatetime] = useState("")
  const [initiativeinfo, setInfo] = useState("");
  //const [initiativeaccepted, setAccepted] = useState("");
  //const [active, setActive] = useState("");
  // eslint-disable-next-line
  const [token, setTokeni] = useState("");
  //console.log(token);
  const [verified, setVerified] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  // eslint-disable-next-line
  const [executing, setExecuting] = useState(false);
  //console.log(setExecuting);
  const [createInitiative] = useMutation(CREATE_INITIATIVE, {
    refetchQueries: [
      {
        query: FIND_INITIATIVES_BY_MUNICIPALITY,
        variables: { municipality: selectedKunta },
      },
    ],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      //setError(error.graphQLErrors[0].message)
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment)
    };*/
  });
  //console.log(selectedKunta);
  const organsw = useQuery(FIND_ORGANS_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { organmunicipality: selectedKunta },
  });
  useEffect(() => {
    let organss = [];
    //let municipalitiess = [];
    if (organsw.data) {
      //console.log(organsw.data);
      organss = organsw.data.findOrgansByMunicipality;
      //setOrgans(organss);
      //console.log(organss);
      setOrgans(organss);
      //municipalitiess=organsw.data.allOrgans
    }
  }, [selectedKunta, organsw]);
  /*
  const handleChange = (event) => {
    setNewComment(event.target.value)
  }

  const addComment = (event) => {
    event.preventDefault()
    createComment({
      content: newComment,
      important: false,
    })

    setNewComment("")
  }
  */
  /*const uusi = async (event) => {
    //console.log(event)
    const aika = Date.now()
    const pvm = new Date(aika)
    setDatetime(pvm.toString())
    setText(event)
  }*/
  function onChange(value) {
    //console.log("Captcha value:", value);
    setTokeni(value);
    setVerified(!verified);
  }

  const submit = async (event) => {
    event.preventDefault();
    const aika = Date.now();
    const pvm = new Date(aika);
    //setDatetime(pvm.toString())
    createInitiative({
      variables: {
        organid,
        initiativetext,
        municipality: selectedKunta,
        initiativedatetime: pvm.toString(),
        initiativeinfo,
        userid: localStorage.getItem("id"),
        active: true,
      },
    });
    setText("");
    //setDatetime("")
    setOrganid("");
    //setUser("")
    setInfo("");
    setSubmitted(true);
  };
  const getOrgans = () =>
    organs.map((o) => {
      return (
        <MenuItem value={o.organname} key={o.organname}>
          {o.organname}
        </MenuItem>
      );
    });
  if (submitted) {
    return (
      <>
        <h2>{t("headers.addinitiative")}</h2>
        {t("common.formok")}
        <br />
      </>
    );
  } else {
    return (
      <>
        <h2>{t("headers.addinitiative")}</h2>
        <form onSubmit={submit}>
          {t("common.initiative")}
          <br />
          <TextField value={initiativetext} onChange={({ target }) => setText(target.value)} />
          <br />
          <br />
          {t("common.organ")}
          <br />
          <FormControl fullWidth>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={organid}
              label={t("common.municipality")}
              onChange={(e) => setOrganid(e.target.value)}
              style={{ backgroundColor: "white" }}
            >
              {getOrgans()}
            </Select>
          </FormControl>
          <br />
          <br />
          <div style={{ width: "100%", display: "flex", placeContent: "center" }}>
            <ReCAPTCHA sitekey="6Lf6wLIaAAAAAORH1jwBkpv1NzwvaBYa9mpn39GP" onChange={onChange} />
          </div>
          <br />
          <br />
          <Button
            style={{ backgroundColor: "#07575B", color: "#C4DFE6", fontSize: "14px" }}
            type="submit"
            disabled={!verified}
          >
            {submitted ? t("common.done") : executing ? "Verifying" : t("common.send")}
          </Button>
          <br />
          <br />
        </form>
      </>
    );
  }
};

export default InitiativeForm;
